"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.weatherCorrectedLineStyle = exports.weatherCorrectKwhProductionCheckStyle = exports.unselectedToggleCheckStyle = exports.systemProductionLineStyle = exports.systemProductionCheckStyle = exports.systemProductionAreaStyle = exports.solarLineStyle = exports.solarCheckStyle = exports.solarAreaStyle = exports.selfConsumptionLineStyle = exports.selfConsumptionCheckStyle = exports.selfConsumptionAreaStyle = exports.peerV2LineStyle = exports.peerV2CheckStyle = exports.peerV2AreaStyle = exports.peerCheckStyle = exports.peerAdjGenerationsLineStyle = exports.meterLineStyle = exports.meterBarStyle = exports.meterAreaStyle = exports.invisibleLineStyle = exports.importLineStyle = exports.importCrosshatchStyle = exports.importCheckStyle = exports.importAreaStyle = exports.exportLineStyle = exports.exportCrosshatchStyle = exports.exportCheckStyle = exports.estimatedSolarAreaStyle = exports.estimatedProductionLineStyle = exports.estimatedKwhProductionCheckStyle = exports.dashedGridStyle = exports.contractGenerationsLineStyle = exports.contractCheckStyle = exports.consumptionLineStyle = exports.consumptionCheckStyle = exports.consumptionBarStyle = exports.borderStyle = exports.billedKwhLineStyle = exports.billedKwhCheckStyle = exports.batteryDischargeStyle = exports.batteryDischargeCheckStyle = exports.batteryChargeStyle = exports.batteryChargeCheckStyle = exports.axisStyle = void 0;

var _colors = require("./constants/colors");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var strokeWidth = 1;
var lineStyle = {
  fill: 'none',
  strokeWidth: strokeWidth
};
var axisStyle = {
  line: {
    stroke: 'none'
  },
  ticks: {
    stroke: 'none'
  },
  text: {
    fontSize: 12,
    fill: _colors.NAVY
  }
};
exports.axisStyle = axisStyle;
var batteryChargeCheckStyle = {
  backgroundColor: _colors.BATTERY_CHARGED
};
exports.batteryChargeCheckStyle = batteryChargeCheckStyle;
var batteryChargeStyle = {
  fill: _colors.BATTERY_CHARGED,
  stroke: 'none'
};
exports.batteryChargeStyle = batteryChargeStyle;
var batteryDischargeCheckStyle = {
  backgroundColor: _colors.BATTERY_DISCHARGED
};
exports.batteryDischargeCheckStyle = batteryDischargeCheckStyle;
var batteryDischargeStyle = {
  fill: _colors.BATTERY_DISCHARGED,
  stroke: 'none'
};
exports.batteryDischargeStyle = batteryDischargeStyle;

var billedKwhLineStyle = _objectSpread(_objectSpread({}, lineStyle), {}, {
  stroke: _colors.BILLED
});

exports.billedKwhLineStyle = billedKwhLineStyle;
var billedKwhCheckStyle = {
  backgroundColor: _colors.BILLED
};
exports.billedKwhCheckStyle = billedKwhCheckStyle;
var borderStyle = {
  bottom: {
    fill: _colors.WHITE
  },
  left: {
    fill: _colors.WHITE
  },
  right: {
    fill: _colors.WHITE
  },
  top: {
    fill: 'transparent'
  }
};
exports.borderStyle = borderStyle;
var contractCheckStyle = {
  backgroundColor: _colors.CONTRACTED
};
exports.contractCheckStyle = contractCheckStyle;

var contractGenerationsLineStyle = _objectSpread(_objectSpread({}, lineStyle), {}, {
  stroke: _colors.CONTRACTED
});

exports.contractGenerationsLineStyle = contractGenerationsLineStyle;
var consumptionBarStyle = {
  stroke: _colors.CONSUMPTION,
  fill: _colors.CONSUMPTION
};
exports.consumptionBarStyle = consumptionBarStyle;
var consumptionCheckStyle = {
  backgroundColor: _colors.CONSUMPTION
};
exports.consumptionCheckStyle = consumptionCheckStyle;
var consumptionLineStyle = {
  stroke: _colors.CONSUMPTION,
  strokeWidth: strokeWidth
};
exports.consumptionLineStyle = consumptionLineStyle;
var dashedGridStyle = {
  stroke: _colors.CCC,
  strokeDasharray: 5,
  strokeWidth: 0.5
};
exports.dashedGridStyle = dashedGridStyle;

var estimatedProductionLineStyle = _objectSpread(_objectSpread({}, lineStyle), {}, {
  stroke: _colors.ESTIMATED_PRODUCTION,
  strokeDasharray: 5
});

exports.estimatedProductionLineStyle = estimatedProductionLineStyle;
var estimatedKwhProductionCheckStyle = {
  backgroundColor: _colors.ESTIMATED_PRODUCTION
};
exports.estimatedKwhProductionCheckStyle = estimatedKwhProductionCheckStyle;
var estimatedSolarAreaStyle = {
  fill: _colors.ESTIMATED_SOLAR_OVERLAY,
  stroke: 'none'
};
exports.estimatedSolarAreaStyle = estimatedSolarAreaStyle;
var exportCrosshatchStyle = {
  fill: _colors.EXPORT,
  stroke: _colors.EXPORT,
  strokeWidth: strokeWidth
};
exports.exportCrosshatchStyle = exportCrosshatchStyle;
var exportCheckStyle = {
  backgroundColor: _colors.EXPORT
};
exports.exportCheckStyle = exportCheckStyle;
var exportLineStyle = {
  fill: 'none',
  stroke: _colors.EXPORT,
  strokeDasharray: 5,
  strokeWidth: strokeWidth
};
exports.exportLineStyle = exportLineStyle;
var importCrosshatchStyle = {
  fill: _colors.IMPORT_COLOR,
  stroke: _colors.IMPORT_COLOR,
  strokeWidth: strokeWidth
};
exports.importCrosshatchStyle = importCrosshatchStyle;
var importCheckStyle = {
  backgroundColor: _colors.IMPORT_COLOR
};
exports.importCheckStyle = importCheckStyle;
var importAreaStyle = {
  fill: _colors.IMPORT_COLOR,
  stroke: 'transparent'
};
exports.importAreaStyle = importAreaStyle;

var importLineStyle = _objectSpread(_objectSpread({}, lineStyle), {}, {
  strokeDasharray: 5,
  stroke: _colors.IMPORT_COLOR
});

exports.importLineStyle = importLineStyle;
var invisibleLineStyle = {
  fill: 'none',
  stroke: 'none'
};
exports.invisibleLineStyle = invisibleLineStyle;
var meterAreaStyle = {
  fill: _colors.METER_OPAQUE,
  stroke: _colors.METER
};
exports.meterAreaStyle = meterAreaStyle;
var meterBarStyle = {
  stroke: _colors.METER,
  fill: _colors.METER
};
exports.meterBarStyle = meterBarStyle;

var meterLineStyle = _objectSpread(_objectSpread({}, lineStyle), {}, {
  stroke: _colors.METER
});

exports.meterLineStyle = meterLineStyle;
var peerCheckStyle = {
  backgroundColor: _colors.PEER_ADJ
};
exports.peerCheckStyle = peerCheckStyle;
var peerV2CheckStyle = {
  backgroundColor: _colors.PEER_V2
};
exports.peerV2CheckStyle = peerV2CheckStyle;

var peerAdjGenerationsLineStyle = _objectSpread(_objectSpread({}, lineStyle), {}, {
  stroke: _colors.PEER_ADJ
});

exports.peerAdjGenerationsLineStyle = peerAdjGenerationsLineStyle;

var peerV2LineStyle = _objectSpread(_objectSpread({}, lineStyle), {}, {
  stroke: _colors.PEER_V2
});

exports.peerV2LineStyle = peerV2LineStyle;
var peerV2AreaStyle = {
  fill: _colors.PEER_V2_OPAQUE,
  stroke: 'transparent'
};
exports.peerV2AreaStyle = peerV2AreaStyle;
var selfConsumptionAreaStyle = {
  fill: _colors.SELF_CONSUMPTION,
  stroke: 'transparent'
};
exports.selfConsumptionAreaStyle = selfConsumptionAreaStyle;
var selfConsumptionCheckStyle = {
  backgroundColor: _colors.SELF_CONSUMPTION
};
exports.selfConsumptionCheckStyle = selfConsumptionCheckStyle;

var selfConsumptionLineStyle = _objectSpread(_objectSpread({}, lineStyle), {}, {
  strokeDasharray: 5,
  stroke: _colors.CONSUMPTION
});

exports.selfConsumptionLineStyle = selfConsumptionLineStyle;
var solarAreaStyle = {
  fill: _colors.SOLAR_OPAQUE,
  stroke: _colors.SOLAR
};
exports.solarAreaStyle = solarAreaStyle;
var solarCheckStyle = {
  backgroundColor: _colors.SOLAR
};
exports.solarCheckStyle = solarCheckStyle;

var solarLineStyle = _objectSpread(_objectSpread({}, lineStyle), {}, {
  stroke: _colors.SOLAR
});

exports.solarLineStyle = solarLineStyle;
var systemProductionAreaStyle = {
  fill: _colors.SOLAR_OPAQUE,
  stroke: _colors.SYSTEM_PRODUCTION
};
exports.systemProductionAreaStyle = systemProductionAreaStyle;
var systemProductionCheckStyle = {
  backgroundColor: _colors.SYSTEM_PRODUCTION
};
exports.systemProductionCheckStyle = systemProductionCheckStyle;

var systemProductionLineStyle = _objectSpread(_objectSpread({}, lineStyle), {}, {
  strokeDasharray: 5,
  stroke: _colors.SYSTEM_PRODUCTION
});

exports.systemProductionLineStyle = systemProductionLineStyle;
var unselectedToggleCheckStyle = {
  backgroundColor: _colors.FADED_GREY
};
exports.unselectedToggleCheckStyle = unselectedToggleCheckStyle;

var weatherCorrectedLineStyle = _objectSpread(_objectSpread({}, lineStyle), {}, {
  stroke: _colors.ESTIMATED_PRODUCTION
});

exports.weatherCorrectedLineStyle = weatherCorrectedLineStyle;
var weatherCorrectKwhProductionCheckStyle = {
  backgroundColor: _colors.ESTIMATED_PRODUCTION
};
exports.weatherCorrectKwhProductionCheckStyle = weatherCorrectKwhProductionCheckStyle;